import { Alert, Button } from "antd";

const ReportError = ({ error, retry }) => (
  <Alert
    className="mb-4"
    type="error"
    showIcon
    message={
      error.httpStatus === 503
        ? "Report historis sementara tidak tersedia"
        : "Report tidak dapat dimuat"
    }
    description={
      error.httpStatus === 503
        ? "Data historis belum siap. Silakan coba lagi nanti."
        : "Silakan coba lagi. Jika masalah berlanjut, hubungi Customer Care."
    }
    action={<Button onClick={retry}>Coba lagi</Button>}
  />
);

export default ReportError;
